import React, { useMemo } from 'react'
import { Button } from '@/components/ui/button'

import { useQueryParams } from '~/hooks/useQueryParams'
import ImpactAreasList from './ImpactAreasList'

interface ImpactedAreasPropType {
  onPressNext: () => void
}

const ImpactedAreas = ({ onPressNext }: ImpactedAreasPropType) => {
  const { list: selectedImpactAreas } = useQueryParams('impact_areas')
  const { setParams } = useQueryParams('impact_areas')

  const selectedImpacts = useMemo(
    () => selectedImpactAreas.map((id) => Number(id)),
    [selectedImpactAreas],
  )
  const handleAddImpactArea = (index: number): void => {
    const updatedImpacts: number[] = [...selectedImpacts]
    if (updatedImpacts.includes(index)) {
      updatedImpacts.splice(updatedImpacts.indexOf(index), 1)
    } else if (selectedImpacts.length >= 3) {
      updatedImpacts[2] = index
    } else {
      updatedImpacts.push(index)
    }
    setParams(updatedImpacts)
  }

  return (
    <div className='m-auto flex h-max w-[90%] max-w-[800px] flex-col items-center bg-white px-9 py-6 sm:px-16 sm:py-12'>
      <h1 className='text-center text-xl font-bold text-black'>
        Select impact areas of interest
      </h1>
      <p className='px-2 py-4 text-center text-[16px] leading-6 text-[#171923]'>
        Select up to 3 impact areas, in order of importance. These will be used
        to identify and rank relevant stories.
      </p>
      <ImpactAreasList
        selectedImpacts={selectedImpacts}
        onImpactAreaClicked={(impactAreaId) => {
          handleAddImpactArea(impactAreaId)
        }}
      />
      <p className='py-4 text-center text-[16px] font-normal leading-6 text-black'>
        {selectedImpactAreas.length >= 3 &&
          'The maximum number of impact areas has been selected'}
      </p>
      <Button
        className='bg-secondary mt-5 h-9 w-16 rounded-sm'
        onClick={() => {
          onPressNext()
        }}
      >
        Next
      </Button>
    </div>
  )
}

export default ImpactedAreas
